module.exports = __webpack_public_path__ + "img/itinerary_collaborate.169a5c1e.svg";